import firebase from './firebase'

const get_file_data = async (attUrl) => {
  const ref = firebase.storage().refFromURL(attUrl)
  const fileRef = firebase.storage().ref(ref.fullPath)
  try {
    const data = await fileRef.getMetadata()
    return {...data, url: attUrl}
  } catch (err) {
    return {}
  }
}

const normalize_filename = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f\n/]/g, "")
}

const upload_file_to_storage = async (base64, fileName, path, fileType) => {
  const storage = firebase.storage()
  const fullPath = `${normalize_filename(path)}/${normalize_filename(fileName)}`
  const storageRef = storage.ref(fullPath)
  const metadata = {
    contentType: fileType
  }

  const uploadResponse = await storageRef.putString(base64, 'base64', metadata)
  
  const downloadURL = await uploadResponse.ref.getDownloadURL()

  return {
    url: downloadURL,
    path: uploadResponse.ref.fullPath
  }
}


export {
  get_file_data,
  upload_file_to_storage,
  normalize_filename
}